import React, { useRef } from 'react';
import Card from '../../Card';
import '../Category.css';
import img1 from  "./hidden-gems-kerala/kerala.webp";
import img2 from  "./must-visit-places-manali/Manali main image.webp";
import img3 from  "./Spiti Valley/Spiti Valley.webp";
import img4 from  "./mathura-vrindavan-travel-guide/मेरो वृन्दावन.png";


export const travelBlogs = [
  {
  id: 'hidden-gems-kerala',
  title: 'Top Hidden Gems to Explore in Kerala',
  summary: 'Uncover Kerala’s offbeat destinations and secret spots for an unforgettable travel experience. Perfect for travelers seeking unique adventures.',
  image: img1
},
{
  id: 'must-visit-places-manali',
  title: '10 Must-Visit Places in Manali for Every Traveler',
  summary: 'Discover the best attractions, scenic viewpoints, and hidden gems in Manali. A complete guide for nature lovers, adventure seekers, and honeymooners alike.',
  image: img2
},
{
  id: 'spiti-valley-travel-story',
  title: 'Spiti Valley — A Soulful Escape Where Silence Speaks',
  summary:'Journey through the raw beauty of Himachal’s Spiti Valley — a land of ancient monasteries, dramatic landscapes, and star-filled skies. Experience the magic of the Himalayas where peace, adventure, and spirituality meet.',
  image: img3
},
{
  id: 'mathura-vrindavan-travel-guide',
  title: 'Mathura–Vrindavan Travel Guide: Top Temples, Experiences & Hidden Spiritual Spots',
  summary: 'Explore the sacred towns of Mathura and Vrindavan — the birthplace of Lord Krishna. Discover famous temples, hidden spiritual gems, ghats, local food, festivals, and travel tips for a soulful journey. Perfect for pilgrims, culture lovers, and history enthusiasts.',
  image: img4
}



];

export default function TravelCategory() {
  const rowRef = useRef(null);

  const scrollLeft = () => {
    rowRef.current.scrollBy({ left: -300, behavior: 'smooth' });
  };

  const scrollRight = () => {
    rowRef.current.scrollBy({ left: 300, behavior: 'smooth' });
  };

  return (
    // <div className="category-section">
    //   <h2 className="categoryhead">Travel the Heart of India</h2>
    //   <div className="scroll-wrapper">
    //     <button className="scroll-btn left" onClick={scrollLeft}>&lt;</button>
    //     <div className="blog-row-horizontal" ref={rowRef}>
    //       {travelBlogs.map(blog => (
    //         <Card key={blog.id} blog={blog} category="travel" />
    //       ))}
    //     </div>
    //     <button className="scroll-btn right" onClick={scrollRight}>&gt;</button>
    //   </div>
    // </div>
       <div className="category-section">
      <h2 className="categoryhead">Travel the Heart of India</h2>
      <div className="scroll-wrapperr">
        <button className="scroll-btnn l" onClick={scrollLeft}>&lt;</button>
        <div className="blog-row-horizontal" ref={rowRef}>
          {travelBlogs.map(blog => (
            <Card key={blog.id} blog={blog} category="travel" />
          ))}
        </div>
        <button className="scroll-btnn r" onClick={scrollRight}>&gt;</button>
      </div>
    </div>
  );
}
